<p-tabView>
  <p-tabPanel>
    <ng-template pTemplate="header"><b>Precision Time Exchange monitoring through MQTT</b> &nbsp;
      <i class="fa fa-circle" style="cursor:default"
         [ngClass]="{'text-warnig': !authenticationService.userAuthenticated, 'text-danger': awsService.awsConfigDataReceived && !awsService.awsTimeSyncMonitoringActivationDate, 'text-success': awsService.awsConfigDataReceived && awsService.awsTimeSyncMonitoringActivationDate}"
         [title]="awsService.awsTimeSyncMonitoringActivationDate ? 'Activated' : 'Need activation'">
      </i>
    </ng-template>
    <p-fieldset [toggleable]="true">
      <p-header> MQTT technical data</p-header>
      <div>
        <div class="info">
          You can have access to your precision time exchange monitoring every minute also through Amazon MQTT or WSS protocols
          using the IoT Core AWS service on endpoint: '/time_sync'<br>
          <br>
          See <a href="https://docs.aws.amazon.com/iot/latest/developerguide/iot-connect-devices.html"
                 target="_blank">AWS documentation</a>
          and <a href="https://docs.aws.amazon.com/iot/latest/developerguide/x509-client-certs.html" target="_blank">authentication
          using certificates</a>.<br>
          Access certificates are created and provided at the activation. <br>
          <br>
          For assistance, please contact <a href="mailto:support@mckay-brothers.com">support&#64;mckay-brothers.com</a>
          <br>
        </div>
      </div>
      <div class="certificate-data">
        MQTT: <b>host</b>: {{ awsService.pythonSampleHost }} &nbsp; <b>port</b>: 8883 <br>
        ClientId: {{ awsService.pythonSampleCompanyId }} <br>
        Topic name: iot{{ awsService.pythonSampleCompanyId }}/time_sync<br>
        <div *ngIf="awsService.awsMqttKeys">
          Download needed files: (click on each one) <br>
          &nbsp; &nbsp;<a (click)="awsService.onClickDownloadRootCat()"><i class="fa fa-file"></i> Root CA</a><br>
          &nbsp; &nbsp;<a (click)="awsService.onClickDownloadCertPem()"><i class="fa fa-file"></i> Certificate
          Pem</a><br>
          &nbsp; &nbsp;<a (click)="awsService.onClickDownloadPrivateKey()"><i class="fa fa-file"></i> Private Key</a>
        </div>
        <div *ngIf="!awsService.awsMqttKeys">
          Needed files: (available when activated)<br>
          &nbsp; &nbsp;<i class="fa fa-file"></i> Root CA<br>
          &nbsp; &nbsp;<i class="fa fa-file"></i> Certificate Pem<br>
          &nbsp; &nbsp;<i class="fa fa-file"></i> Private Key
        </div>
      </div>
      <br>

      <table class="tablexxx table-striped table-bordered table-sm"
             *ngIf="isUserConnected && awsService.awsConfigDataReceived">
        <tr>
          <th>Precision Time Exchange monitoring data</th>
          <td>
            <i class="fa fa-circle" style="cursor:default"
               [ngClass]="{'text-danger': !awsService.awsTimeSyncMonitoringActivationDate, 'text-success': awsService.awsTimeSyncMonitoringActivationDate}"></i>
          </td>
          <td class="text-center">
              <span class="activated-infoxxx"
                    *ngIf="awsService.awsTimeSyncMonitoringActivationDate === false || awsService.awsTimeSyncMonitoringActivationDate === null">
                <p-button label="Activate MQTT publishing through AWS"
                          (onClick)="awsService.onClickActivateTimeSyncMonitoring()"></p-button>
              </span>
            <span class="activated-infoxxx" *ngIf="awsService.awsTimeSyncMonitoringActivationDate">
                <p-button label="Deactivate MQTT publishing through AWS"
                          (onClick)="awsService.onClickDeactivateTimeSyncMonitoring()"></p-button>
              </span>
          </td>
          <td>
              <span *ngIf="awsService.awsTimeSyncMonitoringActivationDate">
              Activated: {{ awsService.awsTimeSyncMonitoringActivationDate | date:datetimeFormat }}
                &nbsp;({{ awsService.awsTimeSyncMonitoringActivationDate | amTimeAgo }})
              </span>
          </td>
        </tr>
      </table>
    </p-fieldset>

    <div *ngIf="isUserConnected">
      <br>
      <p-fieldset [toggleable]="true">
        <p-header> Python Sample Code</p-header>
        <pre class="code-sample">
import json
import time

from AWSIoTPythonSDK.MQTTLib import AWSIoTMQTTClient, DROP_OLDEST # install AWSIoTPythonSDK with pip

clientId = '{{ awsService.pythonSampleCompanyId }}'
host = '{{ awsService.pythonSampleHost }}'
port = 8883
rootCAPath = 'AWS_KEYS/test/root-CA.crt'
privateKeyPath = 'AWS_KEYS/test/private.pem.key'
certificatePath = 'AWS_KEYS/test/certificate.pem.crt'

myAWSIoTMQTTClient = AWSIoTMQTTClient(clientId)
myAWSIoTMQTTClient.configureEndpoint(host, port)
myAWSIoTMQTTClient.configureCredentials(rootCAPath, privateKeyPath, certificatePath)
myAWSIoTMQTTClient.configureAutoReconnectBackoffTime(1, 32, 20)
myAWSIoTMQTTClient.configureOfflinePublishQueueing(5, DROP_OLDEST)
myAWSIoTMQTTClient.configureDrainingFrequency(2)  # Draining: 2 Hz
myAWSIoTMQTTClient.configureConnectDisconnectTimeout(10)  # 10 sec
myAWSIoTMQTTClient.configureMQTTOperationTimeout(5)  # 5 sec
myAWSIoTMQTTClient.connect()

def custom_callback_test(client, userdata, message):
    print(" ** << Received << a new message: from topic: " + message.topic)
    message_as_string = message.payload.decode()
    message_as_json = json.loads(message_as_string)
    print(message_as_json)
    print("\n")

topic = 'iot{{ awsService.pythonSampleCompanyId }}/time_sync'
myAWSIoTMQTTClient.subscribe(topic, 1, custom_callback_test)
print('Connected, waiting for data ...')
time.sleep(60 * 10)
print('... end')
        </pre>
      </p-fieldset>
    </div>
  </p-tabPanel>
  <p-tabPanel>
    <ng-template pTemplate="header">Precision Time Exchange monitoring data</ng-template>
    <div>
      <p-fieldset [toggleable]="true" *ngIf="etreesClientData">
        <p-header>
          Fields description
        </p-header>
        <b>- port:</b> Port Name <br>
        <b>- client_xco:</b> Cross Connect ID <br>
        <b>- wr_service:</b> WR Service <br>
        <b>- protocol:</b> Protocol <br>
        <b>- date:</b> Date/time of the measure of data <br>

        <b>- Client Service Accuracy Statistics:</b><br>
        <b>&nbsp;&nbsp; - tmas_service:</b> NIST Service Name <br>
        <b>&nbsp;&nbsp; - utc_offset:</b> NIST Service UTC Offset <br>
        <b>&nbsp;&nbsp; - locking_state_to_nist:</b> NIST Service Locking Status <br>
        <b>&nbsp;&nbsp; - locking_state_to_nist_text:</b> NIST Service Locking Status Text <br>
        <b>&nbsp;&nbsp; - locking_state_to_neighbor_nist:</b> NIST Secondary Service Locking Status <br>
        <b>&nbsp;&nbsp; - neighbor_utc_offset:</b> NIST Secondary Service UTC Offset <br>
        <b>&nbsp;&nbsp; - client_time_source_status:</b> Client-Facing Device Time Source Status <br>
        <b>&nbsp;&nbsp; - nb_hops:</b> Number of Hops <br>
        <b>&nbsp;&nbsp; - offset_from_neighbor_nist:</b> NIST Secondary Service Offset From <br>
        <b>&nbsp;&nbsp; - neighbor_nist_service:</b> Secondary NIST Service Name <br>
        <b>&nbsp;&nbsp; - neighbor_locking_state_to_nist:</b> NIST Secondary Service Locking Status <br>

        <b>- Client SFP Port Stats:</b><br>
        <b>&nbsp;&nbsp; - vcc:</b> Voltage <br>
        <b>&nbsp;&nbsp; - rx_pow:</b> Receive Power <br>
        <b>&nbsp;&nbsp; - tx_pow:</b> Transmit Power <br>
        <b>&nbsp;&nbsp; - detect:</b> Detection Status <br>
        <b>&nbsp;&nbsp; - tx_bias:</b> Transmit Bias Current <br>
        <b>&nbsp;&nbsp; - temp:</b> Temperature <br>

        <b>- Client Link Statistics:</b><br>
        <b>&nbsp;&nbsp; - rx_errors:</b> Received Errors <br>
        <b>&nbsp;&nbsp; - link_status:</b> Link Status <br>
        <b>&nbsp;&nbsp; - tx_bytes:</b> Transmitted Bytes <br>
        <b>&nbsp;&nbsp; - tx_errors:</b> Transmit Errors <br>
        <b>&nbsp;&nbsp; - rx_bytes:</b> Received Bytes <br>
        <b>&nbsp;&nbsp; - tx_packets:</b> Transmitted Packets <br>
        <b>&nbsp;&nbsp; - rx_packets:</b> Received Packets <br>

        <b>- Client Service Precision Statistics:</b><br>
        <b>&nbsp;&nbsp; - offset_from_master:</b> Offset from master <br>
        <b>&nbsp;&nbsp; - client_global_status:</b> Client Global Status <br>

        <br>
      </p-fieldset>
      <br>
      <p-fieldset [toggleable]="true" *ngIf="!awsService.crosscosData.lastLoadedData">
        <p-header> Precision Time Exchange Monitoring raw data sample</p-header>
        <pre class="code-sample">{{ sampleTimeSyncMonitoringData|json }}</pre>
      </p-fieldset>
    </div>
  </p-tabPanel>
</p-tabView>
